import { Scheduler } from '@aldabil/react-scheduler';
import { DefaultRecourse, ProcessedEvent } from '@aldabil/react-scheduler/types';
import { useRef, useState } from 'react';
import styled from 'styled-components';
import { SchedulerRef } from '@aldabil/react-scheduler/types';
import { Button, CircularProgress } from '@mui/material';

const Container = styled.div`
  .mode {
    display: flex;
    justify-content: end;
    gap: 15px;
  }
  .loading {
    height: 1000px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

type PropTypes = {
  event: ProcessedEvent[];
  resource: DefaultRecourse[];
  loading: boolean;
  selectDate: Date;
  handleChange?: (date: Date) => void;
};

type EventRenderPropTypes = {
  visitorName: string;
};

function EventRenderer({}: ProcessedEvent & EventRenderPropTypes) {
  return <div></div>;
}

export default function ScheduleCanlendar({
  event,
  resource,
  loading,
  selectDate,
  handleChange = () => {},
}: PropTypes) {
  const scheduleRef = useRef<SchedulerRef>(null);

  return (
    <Container>
      <div className="mode">
        <Button onClick={() => scheduleRef.current?.scheduler.handleState(false, 'agenda')}>Month</Button>
        <Button onClick={() => scheduleRef.current?.scheduler.handleState(true, 'agenda')}>Agenda</Button>
      </div>

      {loading ? (
        <div className="loading">
          <CircularProgress />
        </div>
      ) : (
        <Scheduler
          key={new Date().getTime()}
          selectedDate={selectDate}
          ref={scheduleRef}
          events={event}
          draggable={false}
          editable={false}
          deletable={false}
          view="month"
          height={1000}
          onSelectedDateChange={handleChange}
          resourceViewMode="tabs"
          disableViewNavigator
          resources={resource}
          month={{
            weekDays: [0, 1, 2, 3, 4, 5, 6],
            weekStartOn: 0,
            startHour: 6,
            endHour: 22,

            disableGoToDay: false,
          }}
          resourceFields={{
            idField: 'admin_id',
            textField: 'title',
            avatarField: 'title',
            colorField: 'color',
            subTextField: 'sub_title',
          }}
          stickyNavigation

          // disableViewer
          // onEventClick={() => {
          //   console.log("onEventClick");
          // }}
        />
      )}
    </Container>
  );
}
